import { z } from "zod";

export const addressSchema = z.object({
  line1: z.string().min(1),
  line2: z.string().optional(),
  city: z.string().min(1),
  state: z.string().min(1),
  pincode: z.string().regex(/^\d{6}$/, "6-digit PIN"),
});

export const checkoutSchema = z.object({
  email: z.string().email(),
  phone: z.string().regex(/^\+?[1-9]\d{9,14}$/),
  shipping: addressSchema,
  billingSameAsShipping: z.boolean().default(true),
});
export type CheckoutInput = z.infer<typeof checkoutSchema>;
